import { forAll } from '@ofm/util';

/**
 * @param {HTMLInputElement} input
 */
const updateAriaPressed = input => {
    input.setAttribute('aria-pressed', input.checked ? 'true' : 'false');
};

/**
 * @param {Event} e
 */
const handleUpdate = e => {
    const input = e.currentTarget;
    input.form
        .querySelectorAll(`[name="${input.name}"]`)
        .forEach(updateAriaPressed);
};

forAll('.form-toggle-button', e => {
    e.addEventListener('change', handleUpdate);
    updateAriaPressed(e);
});
